import axios from 'axios';
import routes from '../routes/routes';

export const FETCH_SHIPPING_BEGIN = 'FETCH_SHIPPING_BEGIN';
export const FETCH_SHIPPING_SUCCESS = 'FETCH_SHIPPING_SUCCESS';
export const FETCH_SHIPPING_ERROR = 'FETCH_SHIPPING_ERROR';

export const POST_WITHDRAWAL_BEGIN = 'POST_WITHDRAWAL_BEGIN';
export const POST_WITHDRAWAL_SUCCESS = 'POST_WITHDRAWAL_SUCCESS';
export const POST_WITHDRAWAL_ERROR = 'POST_WITHDRAWAL_ERROR';

export const CHANGE_WITHDRAWAL_MODAL_DISPLAY = 'CHANGE_WITHDRAWAL_MODAL_DISPLAY';

export const fetchShippingBegin = () => ({
  type: FETCH_SHIPPING_BEGIN
});

export const fetchShippingSuccess = (data) => ({
  type: FETCH_SHIPPING_SUCCESS,
  payload: data
});

export const fetchShippingError = (error, status) => ({
  type: FETCH_SHIPPING_ERROR,
  error: error,
  status: status
});

export const postWithdrawalBegin = () => ({
  type: POST_WITHDRAWAL_BEGIN
});

export const postWithdrawalSuccess = (data) => ({
  type: POST_WITHDRAWAL_SUCCESS,
  payload: data
});

export const postWithdrawalError = (error, status) => ({
  type: POST_WITHDRAWAL_ERROR,
  error: error,
  status: status
});

export const displayWithdrawalModalAction = (show) => ({
  type: CHANGE_WITHDRAWAL_MODAL_DISPLAY,
  show: show
});

export function snapshotWithdrawalPoints(withdrawalPointsSelected) {
  return async dispatch => {
    dispatch(postWithdrawalBegin());
    axios({
        method: 'post',
        url: routes.shopping_process_shipping.snapshot_withdrawal_points,
        params: {
          cart_token: retrieveCartToken()
        },
        data: {
          withdrawal_points: withdrawalPointsSelected
        }
      }
    )
      .then(result => {
        dispatch(postWithdrawalSuccess({withdrawalPointsSelected: withdrawalPointsSelected}));
        return result.data;
      }, error => {
        dispatch(postWithdrawalError(error.toLocaleString(), error.response.status));
      })
      .catch(error => {
        dispatch(postWithdrawalError(error.toLocaleString(), 500));
      });
  };
}

export function fetchShipping(shippingMethodsSelected, withdrawalPointsSelected, strategy) {
  return dispatch => {
    dispatch(fetchShippingBegin());

    let data = {
      strategy: strategy
    };
    // null values will not reset the user choices
    if (shippingMethodsSelected !== null) {
      data['shipping_method_selected'] = shippingMethodsSelected;
    }
    if (withdrawalPointsSelected !== null) {
      data['withdrawal_points'] = withdrawalPointsSelected;
    }

    axios({
        method: 'post',
        url: routes.shopping_process_shipping.fetch,
        params: {
          cart_token: retrieveCartToken()
        },
        data: data
      }
    )
      .then(result => {
        dispatch(fetchShippingSuccess(result.data));
        return result.data;
      }, error => {
        dispatch(fetchShippingError(error.toLocaleString(), error.response.status));
      }).catch(error => {
        dispatch(fetchShippingError(error.toLocaleString(), 500));
    });
  };
}

export function showWithdrawalModal() {
  return dispatch => {
    dispatch(displayWithdrawalModalAction(true))
  }
}

export function hideWithdrawalModal() {
  return dispatch => {
    dispatch(displayWithdrawalModalAction(false))
  }
}

function retrieveCartToken() {
  return document.getElementById('shipping-page').dataset.cartToken;
}
